module.exports = __webpack_public_path__ + "media/audio38.31b45fa0.mp3";